module.exports = __webpack_public_path__ + "static/media/onboarding.4494afff.png";